export default __webpack_public_path__ + "static/media/close.a43cf51e.svg";